<template>
  <div
    :class="{
      excluded: hoverCand == candidate.email,
    }"
  >
    <div
      class="kanban-main-cards d-flex"
      :style="!tagFiltered && 'border-radius: 8px !important'"
    >
      <div class="w-15 position-relative">
        <div
          class="mr-2 position-relative"
          :class="
            showGrayTick
              ? 'avatar-gray-tick'
              : showWhiteTick
              ? 'avatar-blue-tick'
              : candidate.customFields &&
                candidate.customFields.imageMedia &&
                candidate.customFields.imageMedia != null
              ? 'common-sm-profile-transparet-icon'
              : 'common-sm-profile-icon'
          "
        >
          <template
            v-if="
              !triggerReport &&
              !sendScreening &&
              (!triggerCVS || candidate.cvsStatus == 2)
            "
          >
            <b-avatar
              v-if="
                candidate.customFields &&
                candidate.customFields.imageMedia &&
                candidate.customFields.imageMedia != null
              "
              :src="candidate.customFields.imageMedia"
            ></b-avatar>
            <b-avatar v-else :text="candidate.name[0].toUpperCase()"></b-avatar>
          </template>
          <b-avatar
            v-else-if="triggerReport"
            button
            @click="$emit('trigger-report-cand')"
            :src="getTriggerIcon"
          ></b-avatar>
          <b-avatar
            v-else
            button
            @click="$emit('trigger-cvs-cand')"
            :src="getTriggerIcon"
          ></b-avatar>
        </div>
      </div>
      <div class="w-85">
        <div class="d-flex">
          <div class="w-75 text-truncate kanban-maincards-mainhead">
            {{ candidate.name }}
          </div>
          <div
            class="w-25 d-flex align-items-center position-relative"
            :class="candidate.status == 1 ? 'justify-content-end' : ''"
          >
            <img
              v-if="
                selectedCandidate.candidateID == candidate.candidateID &&
                viewCandidateModal
              "
              src="../../assets/img/newcreatejob/hideicon.svg"
              alt=""
              class="pointer"
            />
            <img
              v-else
              :class="isSchedule && 'disabled-kanban-img'"
              @click="!isSchedule && $emit('view-candidate')"
              src="../../assets/img/newkanban/view.svg"
              alt=""
              class="pointer"
            />
            <img
              v-if="candidate.status != 2 && candidate.status != 1"
              @click.stop="
                isSchedule || jobOnHold
                  ? ''
                  : selectedID != candidate.email
                  ? selectCand()
                  : closeCand()
              "
              :class="(isSchedule || jobOnHold) && 'disabled-kanban-img'"
              class="ml-2 kanban-image-hover pointer"
              src="../../assets/img/newkanban/more.svg"
              alt=""
            />

            <div
              :ref="'closecard' + candidate.email"
              class="kanban-more-option-card"
              v-if="selectedID == candidate.email"
            >
              <div
                v-if="
                  candidate.processingFailed ||
                  !candidate.resumeRating ||
                  candidate.resumeRating < 5
                "
                class="kanban-more-option-card-input"
                @click="$emit('re-analyze'), closeCand()"
              >
                <img
                  src="../../assets/new-kanban-icons/refreshBlog.svg"
                  height="15"
                  width="15"
                  class="mr-1"
                  alt=""
                />
                Re-analyze Profile
              </div>
              <div
                v-if="!candidate.processing"
                class="kanban-more-option-card-input"
                @click="approveModal()"
              >
                <img
                  src="../../assets/img/newkanban/moreoptionicons/approval.svg"
                  class="mr-1"
                  alt=""
                />
                Move to Qualified
              </div>
              <div
                v-if="roles.includes('REASSIGN_CANDIDATE')"
                class="kanban-more-option-card-input"
                @click="$emit('re-assign')"
              >
                <img
                  src="../../assets/img/newkanban/moreoptionicons/reassign.svg"
                  class="mr-1"
                  alt
                />
                Reassign
              </div>
            </div>
          </div>
        </div>
        <div class="d-flex align-items-center">
          <img src="../../assets/img/newkanban/mail.svg" alt="" />
          <span class="w-70 text-truncate kanban-maincards-mailncall ml-1">
            {{ candidate.email }}
          </span>
        </div>
        <div class="mt-1 w-100">
          <div class="d-flex align-items-center justify-content-between w-100">
            <div
              class="tip-learn-more font-lato"
              v-if="triggerCVS && candidate.cvsStatus == 2"
            >
              CVS Score:
              <span class="fw-600">{{
                candidate.cvsScore ? `${candidate.cvsScore}/50` : "0/50"
              }}</span>
            </div>
            <div v-else class="kanban-maincards-mailncall">
              <img src="../../assets/img/newkanban/phone.svg" alt="" />
              {{ candidate.phoneNumber }}
            </div>
            <div
              v-if="
                !sendScreening &&
                !triggerCVS &&
                (candidate.processing || candidate.processingFailed)
              "
              class="kanban-maincards-processing"
              :style="
                candidate.processingFailed
                  ? 'color: #eb0002;'
                  : 'color: #20639b;'
              "
            >
              {{ candidate.processingFailed ? "Failed" : "Processing" }}
            </div>
            <div
              v-else-if="!triggerCVS && !sendScreening && !triggerReport"
              class="kanban-maincards-nottriggered"
              :style="
                candidate.resumeRating &&
                candidate.resumeRating >= particularJob.threshold
                  ? 'color: #038e00'
                  : 'color: #eb0002'
              "
            >
              {{ candidate.resumeRating ? candidate.resumeRating : 0 }}% Match
            </div>
            <div
              v-else-if="triggerReport"
              class="kanban-maincards-nottriggered"
              :style="reportStatus.style"
              v-b-tooltip.hover.bottom="reportStatus.tooltip"
            >
              {{ reportStatus.label }}
            </div>
            <div
              v-else-if="triggerCVS"
              class="kanban-maincards-nottriggered"
              :style="
                candidate.cvsStatus == 1
                  ? 'color: #8C8C8C;'
                  : candidate.cvsStatus == 2
                  ? 'color: #038E00;'
                  : 'color: #20639B;'
              "
            >
              {{ getCVSStatus }}
            </div>
            <div
              v-else-if="sendScreening && getScreeningNames.length != 0"
              class="
                kanban-maincards-nottriggered
                text-truncate
                d-inline-block
                defaultCursor
              "
              style="color: #20639b; max-width: 105px"
              :style="
                getScreeningNames.length > 1
                  ? 'width: 105px;'
                  : 'max-width: 105px;'
              "
            >
              <div
                v-if="getScreeningNames.length > 1"
                class="d-flex flex-wrap justify-content-center"
              >
                <b-avatar-group class="common-avatar-white-border">
                  <b-avatar
                    class="screening-panel-avatar"
                    v-for="(panel, index) in getScreeningNames.slice(0, 4)"
                    :key="index"
                    :text="panel[0]"
                    v-b-tooltip.hover.bottom="panel"
                  >
                  </b-avatar>
                  <b-avatar
                    v-b-tooltip.hover.bottom="
                      getScreeningNames.slice(4).join(', ')
                    "
                    v-if="getScreeningNames.length > 4"
                    class="panel-lightblue-div pointer"
                  >
                    +{{ getScreeningNames.length - 4 }}
                  </b-avatar>
                </b-avatar-group>
              </div>
              <span v-b-tooltip.hover.bottom="getScreeningNames[0]" v-else>{{
                getScreeningNames[0]
              }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      ref="container"
      v-if="
        tagFiltered &&
        candidate.customFields.notesTags &&
        candidate.customFields.notesTags.length != 0
      "
      class="kanbancard-tags-container d-flex align-items-center gap-10"
    >
      <div
        v-for="(tag, index) in visibleTags"
        :key="index"
        class="kanbancards-skilltags fs-12 fw-400 font-lato color-mainblue"
        :style="
          visibleTags.length == 1 &&
          (remainingCount > 1 ||
            (remainingCount === 1 && visibleTags.length > 0)) &&
          'max-width: 195px !important;'
        "
        :class="visibleTags.length == 1 && 'kanban-tag-truncate'"
      >
        #{{ tag }}
      </div>

      <div
        :ref="'showmoreskills' + candidate.candidateID"
        v-if="
          remainingCount > 1 || (remainingCount === 1 && visibleTags.length > 0)
        "
        :id="'showmoreskills' + candidate.candidateID"
        class="
          kanbancards-skilltags
          fs-12
          fw-400
          font-lato
          color-mainblue
          pointer
        "
      >
        +{{ remainingCount }} more
      </div>
      <b-tooltip
        @shown="onTooltipShown"
        ref="tooltip"
        :target="'showmoreskills' + candidate.candidateID"
        triggers="click"
        placement="bottom"
        @hidden="$emit('show-blur', false)"
        :id="'tooltip' + candidate.candidateID"
        :custom-class="'kanban-skill-tooltip'"
      >
        <template
          v-if="candidate.notes && Object.keys(candidate.notes).length != 0"
        >
          <div class="fs-12 fw-600 font-mont color-e0e0e0">
            {{ candidate.notes.noteCreatedBy }}
            <span class="color-abb1b9 fs-11 fw-500 font-lato font-italic">
              ({{ candidate.notes.createdAt }})
            </span>
          </div>
          <div class="font-mont fw-500 fs-12 color-white mt-1">
            {{ candidate.notes.note }}
          </div>
        </template>

        <div
          ref="tooltipTags"
          class="mt-2 d-flex align-items-center gap-10 flex-wrap"
        >
          <div
            v-for="(tag, index) in visibleSubTags"
            :key="index"
            class="kanbancards-skilltags fs-12 fw-400 font-lato color-mainblue"
          >
            #{{ tag }}
          </div>
          <div
            @click="$emit('view-candidate', 'show-note')"
            v-if="count > 0"
            class="
              kanbancards-skilltags
              fs-12
              fw-400
              font-lato
              color-mainblue
              pointer
            "
          >
            +{{ count }} more
          </div>
        </div>
      </b-tooltip>
    </div>
    <KanbanCommentModal
      v-if="isAcceptReject"
      :showAddComment="isAcceptReject"
      :label="'Remarks'"
      :heading="'Move to Qualified'"
      :remarksRequired="true"
      @close-modal="closeAcceptReject"
      @btn2-action="btn2Action"
    />
  </div>
</template>

<script>
import KanbanCommentModal from "../Kanban/modal/KanbanCommentModal.vue";
import { selectCandidatetoJD } from "../../utils/apiFunctions";
import toast from "../mixin/toast";
import { mapGetters } from "vuex";
import {
  getCVSStatus,
  showWhiteTick,
  showGrayTick,
  getTriggerIcon,
  calculateVisibleSubTags,
  calculateVisibleTags,
  removeTooltip,
} from "./kanbanHelpers";
export default {
  name: "kanbanrejected",
  data() {
    return {
      isAcceptReject: false,
      visibleTags: [],
      remainingCount: 0,
      visibleSubTags: [],
      count: 0,
    };
  },
  mixins: [toast],
  props: {
    candidate: Object,
    selectedID: String,
    process: Object,
    isSchedule: Boolean,
    jobOnHold: Boolean,
    selectedCandidate: Object,
    viewCandidateModal: Boolean,
    particularJob: Object,
    triggerCVS: Boolean,
    triggerReport: Boolean,
    triggerCands: Array,
    sendScreening: Boolean,
    tagFiltered: Boolean,
    hoverCand: String,
  },
  components: {
    KanbanCommentModal,
  },
  mounted() {
    document.addEventListener("click", this.closeOnOutside);
    if (
      this.candidate.customFields.notesTags &&
      this.candidate.customFields.notesTags.length != 0
    ) {
      this.calculateVisibleTags();
      this.calculateVisibleSubTags(this.candidate.customFields.notesTags);
      window.addEventListener("resize", this.calculateVisibleTags);
    }
  },
  beforeDestroy() {
    document.removeEventListener("click", this.closeOnOutside);
    if (
      this.candidate.customFields.notesTags &&
      this.candidate.customFields.notesTags.length != 0
    ) {
      window.removeEventListener("resize", this.calculateVisibleTags);
    }
  },
  computed: {
    getScreeningNames() {
      return this.candidate.screeningAssignedTo.map((obj) => {
        return this.formattedData(obj.username);
      });
    },
    getCVSStatus() {
      return getCVSStatus(this.candidate);
    },
    ...mapGetters({ roles: "roles" }),
    ...mapGetters("jobDescriptionVUEX", {
      customerDetail: "getCustomerDetail",
    }),
    getTriggerIcon() {
      return getTriggerIcon(this);
    },
    reportStatus() {
      if (this.candidate.reportUpdateAvailable)
        return {
          label: "Update available",
          style: "color: #038E00;",
          tooltip: "CVS was taken after this report was generated",
        };
      if (!this.candidate.reportKey)
        return {
          label: "No report",
          style: "color: #20639B;",
          tooltip: "No match report generated yet",
        };
      return {
        label: this.candidate.recommendation
          ? this.verdictLabel(this.candidate.recommendation)
          : "View Report",
        style: this.candidate.recommendation
          ? this.verdictColor(this.candidate.recommendation)
          : "color: #8C8C8C;",
        tooltip: "Report reflects all available evidence",
      };
    },
    showWhiteTick() {
      return showWhiteTick(this);
    },
    showGrayTick() {
      return showGrayTick(this);
    },
  },
  methods: {
    verdictLabel(rec) {
      if (rec.fit) return rec.fit.band;
      const map = { ADVANCE: "Strong Fit", HOLD: "Review", REJECT: "No Fit" };
      return (rec && map[rec.decision]) || "View Report";
    },
    verdictColor(rec) {
      const token = rec && rec.fit && rec.fit.token;
      if (token) {
        const tokenColors = {
          good: "#038e00",
          warn: "#ffc145",
          crit: "#eb0002",
          neu: "#5a6472",
        };
        return `color: ${tokenColors[token] || "#5a6472"}`;
      }
      const decision = rec && rec.decision;
      if (decision === "ADVANCE") return "color: #038e00";
      if (decision === "REJECT") return "color: #eb0002";
      return "color: #ffc145";
    },
    removeTooltip() {
      removeTooltip(this);
    },
    onTooltipShown() {
      this.$emit("show-blur", true);
    },
    calculateVisibleTags() {
      calculateVisibleTags(this);
    },
    calculateVisibleSubTags(tags) {
      calculateVisibleSubTags(tags, this);
    },
    formattedData(data) {
      return data.replace(/\b\w/g, (char) => char.toUpperCase());
    },
    selectCand() {
      if (!this.type && this.hoverCand == this.candidate.email)
        this.removeTooltip();
      this.$emit("select-cand", this.candidate.email);
    },
    closeCand() {
      this.$emit("select-cand", "");
    },
    approveModal() {
      this.isAcceptReject = true;
    },
    closeAcceptReject() {
      this.isAcceptReject = false;
    },
    async btn2Action(remarks) {
      try {
        let payload = {
          jobID: this.$route.query.jobID,
          emailID: this.candidate.email,
          select: true,
          remarks: remarks,
          lead: this.customerDetail.lead,
        };
        const res = await selectCandidatetoJD(payload);
        if (res.status == 200) {
          var toastText = `Candidate "${this.candidate.name}" has been moved to qualified.`;
          this.dynamicToast("success", "Successfully Qualified", toastText);
          this.closeAcceptReject();
          this.$emit("update-details");
        } else {
          this.closeAcceptReject();
          this.errorModal("Something went wrong");
        }
      } catch (error) {
        this.closeAcceptReject();
        this.errorModal("Something went wrong");
      }
    },
    closeOnOutside(event) {
      let id = "closecard" + this.candidate.email;
      if (this.$refs[id] && !this.$refs[id].contains(event.target)) {
        this.$emit("select-cand", "");
        // Close the dropdown
      }
      const triggerRef =
        this.$refs["showmoreskills" + this.candidate.candidateID];
      // const tooltipEl = document.getElementById("tooltip-" + this.candidate.candidateID);
      // If click is outside both the trigger and the tooltip, close
      if (triggerRef && !triggerRef.contains(event.target)) {
        this.removeTooltip();
      }
    },
  },
};
</script>

<style scoped>
.kanban-maincards-processing {
  padding: 3px 10px;
  font-family: "Lato", sans-serif;
  font-weight: 600;
  font-style: italic;
  font-size: 12px;
  background: #f6f9fb;
  border-radius: 8px;
  display: flex;
  justify-content: center;
}
</style>
